import { Injectable, inject } from '@angular/core';
import { SiaIconBadgeApi } from '../apis/sia-icon-badge.api';
// declare function manageIconBadge(value: any): void;

// declare global {
//   interface Navigator {
//     setClientBadge(number: number): void;
//   }
// }

@Injectable({
  providedIn: 'root',
})
export class SiaIconBadgeService {
  private iconBadgeApi = inject(SiaIconBadgeApi);

  /** Inserted by Angular inject() migration for backwards compatibility */

  constructor() {}

  // Documentazione:
  // QUesto è un documento 'teorico' di come dovrebbe essere l'api, tuttavia non implementato
  // https://github.com/w3c/badging/blob/main/explainer.md
  async setBadge(badgeValue: number) {
    if (!navigator.setAppBadge) {
      return;
    }

    await this.checkPermission();
    try {
      await navigator.setAppBadge(badgeValue);
    } catch (e: any) {
      // The badge is not supported, or the user has prevented the app
      // from setting a badge.
    }
    // Vecchia versione
    // if (badgeValue === null) {
    // } else {
    //   manageIconBadge(badgeValue);
    // }
  }

  private async checkPermission() {
    let permission = await navigator.permissions.query({
      name: 'notifications',
    });
    if (permission.state === 'prompt') {
      // Prompt the user to grant permission.
      await Notification.requestPermission();
    }
  }
}
